<div class="container" mat-dialog-content>
    <h2>New Category</h2>

    <mat-form-field class="name-input" appearance="outline">
        <mat-label>Category name</mat-label>
        <input matInput [(ngModel)]="name">
        <mat-hint>Avoid pural name</mat-hint>
    </mat-form-field>
</div>

<div class="footer" mat-dialog-actions>
    <div class="left">
        <button mat-dialog-close mat-raised-button>Close</button>
    </div>
    <div class="right">
        <button (click)="save()" mat-raised-button>Save</button>
    </div>
</div>